import { styled } from "@mui/material/styles";
import { useDispatch } from "react-redux";

import { DatePicker } from "@mui/x-date-pickers";
import { Grid, Typography } from "@mui/material";
import React, { useState, Fragment, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import {
  Autocomplete,
  LoadingButton,
  MandatoryNote,
  SelectField,
  TextField,
} from "../../../../../components";
import { useAlert, useAxios } from "../../../../../hooks";
import { debounce } from "lodash";
import { Formik } from "formik";
import * as yup from "yup";
import FormTwo from "./FormTwo";

const TextFieldWithCSS = styled(TextField)`
  .MuiOutlinedInput-notchedOutline {
    border: 1px solid rgb(0 0 0 / 37%);

    border-radius: 12.5px;
  }

  .MuiOutlinedInput-root {
    font-size: 15px;
  }

  & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.1);
  }

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.1);
  }

  .MuiInputLabel-root {
    color: rgba(0, 0, 0, 0.38);
  }

  .Mui-disabled {
    -webkit-text-fill-color: rgba(0, 0, 0, 0.7);
    background-color: #f5f5f5;
    font-size: 15px;
    border-radius: 12.5px;
  }

  .Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: #f5f5f5;
  }

  .MuiInputLabel-asterisk {
    color: ${(props) => (Boolean(props.required && !props.value) ? "red" : "")};
  }
`;

function Form({
  formik,
  premises,
  premisesID,
  setCustomFields,
  setDepartments,
  setStepperLevel,
}) {
  const [formData, setFormData] = useState({
    department: "",
    subDepartment: "",
    officer: "",
    premises: premisesID,
  });

  const validationSchema = yup.object().shape({
    // department: yup.string().required("Department is required"),
    subDepartment: yup.string().required("Sub-department is required"),
    officer: yup.string().required("Officer is required"),
    premises: yup.string().required("Premises is required"),
  });

  return (
    <Fragment>
      <Formik
        initialValues={formData}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(formData) => {
          formik.setValues((prev) => ({
            ...prev,
            ...formData,
          }));
          setStepperLevel(1);
        }}
      >
        {(formikProps) => {
          return (
            <Fragment>
              <FormTwo
                formikProps={formikProps}
                premises={premises}
                setCustomFields={setCustomFields}
                setDepartments={setDepartments}
              />
            </Fragment>
          );
        }}
      </Formik>
    </Fragment>
  );
}

export default Form;
